/** Small pieces both vehicle pages show the same way. */

import { Badge } from '@/components/ui';
import { useI18n } from '@/i18n';
import type { Vehicle } from '@/lib/api';

/** "Fiat Doblò (Furgone bianco)", or whatever part of that is known. */
export function vehicleTitle(v: Pick<Vehicle, 'name' | 'make' | 'model' | 'year'>): string {
  const makeModel = [v.make, v.model].filter(Boolean).join(' ');
  const base = makeModel || v.name || '';
  const extra = makeModel && v.name ? ` (${v.name})` : '';
  return `${base}${extra}${v.year ? ` · ${v.year}` : ''}` || '—';
}

export function StatusBadge({ status }: { status: Vehicle['status'] }) {
  const { t } = useI18n();
  const tone =
    status === 'available' ? 'success' : status === 'assigned' ? 'primary' : status === 'maintenance' ? 'warning' : 'neutral';
  return <Badge tone={tone}>{t(`vehicles.status.${status}`)}</Badge>;
}

/** One word for the papers: the worst thing about them, or that they are in order. */
export function DocumentsBadge({ vehicle }: { vehicle: Pick<Vehicle, 'documents'> }) {
  const { t } = useI18n();
  const d = vehicle.documents;
  if (d.expired > 0) return <Badge tone="danger">{t('vehicles.docsExpired', { count: d.expired })}</Badge>;
  if (d.missing > 0) return <Badge tone="danger">{t('vehicles.docsMissing', { count: d.missing })}</Badge>;
  if (d.expiring > 0) return <Badge tone="warning">{t('vehicles.docsExpiring', { count: d.expiring })}</Badge>;
  return <Badge tone="success">{t('vehicles.docsOk')}</Badge>;
}
